import { isEmpty } from 'lodash'

export const transformEmployeeRoleToDisplay = (role) => {
  if (isEmpty(role)) return 'N/A'

  return role === 'manager' ? 'Manager' : 'Cashier'
}

export const transformEmployeeRoleToSend = (role) => {
  switch (role) {
    case 'manager':
      return ['manager']
    case 'cashier':
      return ['supervisor', 'cart_attendant', 'suite_attendant']
    default:
      return null
  }
}

export const transfromActiveValueToSend = (value) => {
  switch (value) {
    case 'active':
      return true
    case 'inactive':
      return false
    default:
      return null
  }
}

export const getValidEmployeeId = (employeeId, orgName, name) => {
  const generatedEmployeeId = generateEmployeeId(orgName, name)

  return isEmpty(employeeId) ? generatedEmployeeId : employeeId
}

export const generateEmployeeId = (orgName, name) => {
  const transformedName = name?.replace(/\s/g, '_')

  const randomString = getRandomAlphaNumericString(-6)

  return `${orgName}_${transformedName}_${randomString}`.toLowerCase()
}

// provide negative number to get random string of that length
export const getRandomAlphaNumericString = (length = -6) =>
  Math.random().toString(36).slice(length)

export const posAccountsUtils = {
  transformEmployeeRoleToDisplay,
  transformEmployeeRoleToSend,
  transfromActiveValueToSend,
  getValidEmployeeId,
  generateEmployeeId,
  getRandomAlphaNumericString,
}
